module.exports = __webpack_public_path__ + "static/Frame.f20e18a7.svg";